import { render } from "./VirtualScrollList.vue?vue&type=template&id=b831d2a8"
import script from "./VirtualScrollList.vue?vue&type=script&lang=js"
export * from "./VirtualScrollList.vue?vue&type=script&lang=js"

import "./VirtualScrollList.vue?vue&type=style&index=0&id=b831d2a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__